export const MetricLabel = ({ children }: { children?: string | null }) =>
  children ? (
    <p className="text-xs font-medium tracking-widest text-brand uppercase">
      {children}
    </p>
  ) : null;
